(function($) {
    'use strict';

    $(document.body)
        .on('click', '.woocommerce-mini-cart__buttons .checkout', function(e) {
            $(this).addClass('loading');
        });

    $(document.body)
        .on('click', '.toggle-variation', function(e) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('span').text('Visa information');
                $(this).next().removeClass('visible');
            } else {
                $(this).toggleClass('active');
                $(this).find('span').text('Stäng information');
                $(this).next().addClass('visible');
            }
        });

    $(document.body).on('click', '.mini-cart', function(e) {
        if (e.target !== this) {
            return;
        }

        $(document.body).trigger('cart/hide');
    });

    class Cart {
        constructor() {
            $(document.body).on('click', '.cart-toggle', this.show);
            $(document.body).on('click', '.cart-close', this.hide);

            $(document).on('cart/show', this.show);
            $(document).on('cart/hide', this.hide);

            $(document.body).on(
                'click',
                '.woocommerce-mini-cart-item__quantity .negative',
                this.onMiniCartQuantityChange.bind(this, -1),
            );
            $(document.body).on(
                'click',
                '.woocommerce-mini-cart-item__quantity .positive',
                this.onMiniCartQuantityChange.bind(this, 1),
            );

            $(document.body).on(
                'click',
                '.woocommerce-checkout-review-order-table .minus, .woocommerce-checkout-review-order-table .plus',
                this.onCheckoutQuantityChange,
            );
        }

        show = () => {
            $('.mini-cart-wrapper').removeClass('closed');
            $(document.body).addClass('mini-cart--visible');
        };

        hide = () => {
            $('.mini-cart-wrapper').addClass('closed');
            setTimeout(function() {
                $(document.body).removeClass('mini-cart--visible');
                $('.mini-cart-wrapper').removeClass('closed');
            }, 500);
        };

        onMiniCartQuantityChange = (modifier, e) => {
            e.preventDefault();

            const $item = $(e.target).closest('.woocommerce-mini-cart-item');

            const cartItemKey = $item.find('input[name="cart_item_key"]').val();

            const $quantity = $item.find('input[name="quantity"]');
            let quantity = parseInt($quantity.val()) + modifier;
            if (quantity < 0) {
                quantity = 0;
            }

            $quantity.val(quantity);

            $item.block({
                message: null,
                overlayCSS: {
                    opacity: 0.6,
                },
            });

            this.onQuantityChange(cartItemKey, quantity)
                .always(() => $item.unblock());
        };

        onCheckoutQuantityChange = e => {
            e.preventDefault();

            const $table = $('.woocommerce-checkout-review-order-table');

            const $item = $(e.target).closest('.cart_item');

            const cartItemKey = $item
                .find('td.product-quantity')
                .data('cart_item_key');

            const $quantity = $item.find(
                'td.product-quantity .qty',
            );

            $table.block({
                message: null,
                overlayCSS: {
                    opacity: 0.6,
                },
            });

            requestAnimationFrame(() => {
                this.onQuantityChange(cartItemKey, $quantity.val())
                    .always(() => $table.unblock());
            });
        };

        onQuantityChange(cartItemKey, quantity) {
            const data = new FormData();
            data.append('action', 'cart_item_update');
            data.append('cart_item_key', cartItemKey);
            data.append('quantity', quantity);

            return $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    method: 'post',
                    processData: false,
                    contentType: false,
                    data: data,
                })
                .done(data => {
                    if (!data || !data.fragments) {
                        return;
                    }

                    $.each(data.fragments, function(key, value) {
                        $(key).replaceWith(value);
                    });

                    $(document.body).trigger('wc_fragments_refreshed');
                    $(document.body).trigger('update_checkout');
                })
                .fail(() => {
                    new swal(
                        'Kunde inte uppdatera din varukorg. Var vänlig försök igen.',
                    );
                });
        }
    }

    new Cart();
}(jQuery));
